var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-app-btn',{attrs:{"attrs":attrs,"on":on,"btn":_vm.btn}})]}}])},[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.btn.items),function(i,idx){return _c('v-app-bar-menu-item',{key:i.id || i.name || idx,attrs:{"btn":i,"idx":idx}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }